var _rect, _rect2, _polyline, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScada(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 36,
    height: 28,
    rx: 2,
    fill: "#744210",
    stroke: "#5F370E",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 30,
    height: 18,
    rx: 1,
    fill: "#1A202C"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "9,24 15,18 19,21 24,14 29,17 33,12 39,16",
    stroke: "#F6AD55",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 29,
    width: 8,
    height: 3,
    rx: 0.5,
    fill: "#D69E2E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 29,
    width: 8,
    height: 3,
    rx: 0.5,
    fill: "#D69E2E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 8,
    height: 3,
    rx: 0.5,
    fill: "#D69E2E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 34,
    width: 18,
    height: 4,
    fill: "#744210"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 38,
    width: 28,
    height: 2,
    rx: 1,
    fill: "#744210"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScada);
export default __webpack_public_path__ + "static/media/scada.481893abc8246520e582d3cc20f89b05.svg";
export { ForwardRef as ReactComponent };